import { InputText } from "primereact/inputtext";
import { useTranslation } from "react-i18next";
import { ChangeEvent } from "react";

interface InspectionListTableHeaderProps {
    globalFilterValue: string;
    setGlobalFilterValue: (value: string) => void;
}

export const InspectionListTableHeader = ({ globalFilterValue, setGlobalFilterValue }: InspectionListTableHeaderProps) => {
    const { t } = useTranslation("locale");

    const onGlobalFilterChange = (e: ChangeEvent<HTMLInputElement>) => {
        setGlobalFilterValue(e.target.value);
    };

    return (
        <div className="flex justify-content-between align-items-center">
            <h3 className="m-0">{t("inspections.header.selectInspection")}</h3>
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText
                    value={globalFilterValue}
                    onChange={onGlobalFilterChange}
                    placeholder={t("inspections.table.searchInspections")}
                />
            </span>
        </div>
    );
};
